import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditableModule } from '@flyfreely-portal-ui/editable';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FlyFreelyTableModule } from '@flyfreely-portal-ui/flyfreely-table';
import { ResourceUiModule } from '@flyfreely-portal-ui/resource-ui';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ngfModule } from 'angular-file';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { DocumentationModule } from 'libs/documentation/src/lib/documentation.module';
import { FeaturesModule } from 'libs/features/src/lib/features.module';
import { FlightHistoryModule } from 'libs/flight-history/src/lib/flight-history.module';
import { FormDirectivesModule } from 'libs/form-directive/src/lib/form-directive.module';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { MaintenanceModule } from 'libs/maintenance/src/lib/maintenance.module';
import { WorkflowModule } from 'libs/workflows/src/lib/workflows.module';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ToastrModule } from 'ngx-toastr';
import { BatteryAddDialogue } from './add/battery-add-dialgoue.component';
import { NotesEditComponent } from './batteries-notes/notes-edit/notes-edit.component';
import { NotesViewComponent } from './batteries-notes/notes-view/notes-view.component';
import { BatteryDialoguesService } from './battery-dialogues.service';
import { BatteryHealthComponent } from './battery-health/battery-health.component';
import { BatterySetAddDialogue } from './battery-sets/add/battery-set-add-dialgoue.component';
import { BatterySetDetails } from './battery-sets/battery-set-details.component';
import { BatterySetCompatibleRpaComponent } from './battery-sets/compatible-rpa/battery-set-compatible-rpa.component';
import { BatterySetEdit } from './battery-sets/edit/battery-set-edit.component';
import { BatterySetView } from './battery-sets/view/battery-set-view.component';
import { CompatibleRpaTypesComponent } from './battery-types/compatible-rpa-types/compatible-rpa-types.component';
import { BatteryTypeDialogue } from './battery-types/edit/battery-type-dialogue.component';
import { BatteryTypeList } from './battery-types/list/battery-type-list.component';
import { BatteryDetailsDialogue } from './details-dialogue/battery-details-dialogue.component';
import { BatteryDetails } from './details/battery-details.component';
import { BatteryListDownloadDialogue } from './downloads/battery-list-download/battery-list-download-dialogue.component';
import { BatteryEdit } from './edit/battery-edit.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedUiModule,
        // ngx-bootstrap
        TooltipModule,
        ModalModule.forChild(),
        TabsModule,
        BsDropdownModule,
        BsDatepickerModule,
        ButtonsModule,

        // ngx-formly
        ReactiveFormsModule,
        FormlyModule,
        FormlyBootstrapModule,
        FormDirectivesModule,

        // ng-select
        NgSelectModule,

        ngfModule,

        NgxChartsModule,

        ToastrModule, // ToastrModule added
        SharedUiModule,
        LoadingIndicatorModule,
        DocumentationModule,
        WorkflowModule,
        FlightHistoryModule,
        MaintenanceModule,
        ValidationModule,
        FlyFreelyTableModule,
        ResourceUiModule,

        EnhancedHelpModule,
        FeaturesModule,
        AnalyticsModule,
        EditableModule
    ],
    providers: [BatteryDialoguesService],
    declarations: [
        BatteryDetailsDialogue,
        BatteryDetails,
        BatteryEdit,
        BatterySetView,
        BatterySetDetails,
        BatterySetEdit,
        BatteryTypeList,
        BatteryTypeDialogue,
        BatteryAddDialogue,
        BatterySetAddDialogue,
        BatteryListDownloadDialogue,
        BatteryHealthComponent,
        CompatibleRpaTypesComponent,
        BatterySetCompatibleRpaComponent,
        NotesViewComponent,
        NotesEditComponent
    ],
    exports: [BatteryTypeList, CompatibleRpaTypesComponent]
})
export class BatteryModule {}
